
import { defineComponent } from 'vue';
import GlobalEvents from 'vue-global-events';

const observers = new WeakMap();

export default defineComponent({
  name: 'DocumentCover',
  components: {
    GlobalEvents
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    coverZindex: {
      type: Number,
      default: 0
    },
    observe: {
      type: Boolean,
      default: true
    },
    preload: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    invisible: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    everOpened: false
  }),
  watch: {
    open() {
      if (this.open) {
        this.everOpened = true;
        this.$nextTick(this.setupIntersectionObserver);
      } else {
        this.teardownIntersectionObserver();
      }
    }
  },
  // This is only really used in storybook
  mounted() {
    this.setupIntersectionObserver();
  },
  beforeDestroy() {
    this.teardownIntersectionObserver();
  },
  methods: {
    setupIntersectionObserver() {
      if (!('IntersectionObserver' in window) || observers.get(this)) {
        return;
      }

      const el = this.$slots.default[0].elm;

      if (el instanceof Element) {
        const observer = new IntersectionObserver(([change]) => {
          if (!change.isIntersecting) {
            this.$emit('hide');
          }
        });

        observers.set(this, observer);

        observer.observe(el);
      }
    },
    teardownIntersectionObserver() {
      const observer = observers.get(this);
      if (observer) {
        observer.disconnect();
      }
    }
  }
});
